<template>

  <header class="flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat" :style="{ backgroundImage: 'url(' + require(`@/assets/background.jpg`) + ')' }">

    <div class="flex flex-col items-center my-10">
      <img class="object-contain w-12/12" src="@/assets/logo.png" />

      <div class="w-full flex flex-col items-center justify-center py-8 ">
        <div class="flex flex-col md:flex-row w-full md:w-auto gap-2 md:gap-4 px-5 text-center">
          <router-link to="/" class="bg-[#04a6e1] hover:bg-[#0f3449] text-white px-4 py-2 rounded-md transition-all duration-200 cursor-pointer" >
            ACREDITARME
          </router-link>
        </div>  
      </div>

    </div>
  </header>


  <section id="formulario" >

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700 mx-5" @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto max-w-7xl my-7 p-5 lg:p-8 lg:pr-10 bg-white bg-opacity-90 rounded-lg shadow-xl">

      <h1 class="font-bold text-center text-2xl">Credenciales</h1>
      <h1 class="font-bold text-center text-xl">Por favor complete el formulario para descargar su credencial</h1>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Ingrese su número de documento</label>
            <Field name="documento" v-slot="{ field, errors }" v-model="formData.documento">
              <InputText v-bind="field" type="numeric"  placeholder="Documento"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="documento" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit" label="REGISTRARME" class="mt-4 px-4 bg-[#175c8c] hover:bg-[#0f3449] text-white py-2 rounded-md transition-all duration-200" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>DESCARGAR CREDENCIAL
          </button>
        </div>

      </div>

    </Form>

  </section>

  <FullScreenLoader :visible="isSubmitting" text="Descargando credencial..." />

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';

import suiteService, { Acreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { VERIFICADO } from 'qreventos-suite/constantes';
import FullScreenLoader from '@/components/FullScreenLoader.vue';

export default defineComponent({
  components: {
    InputText, FullScreenLoader,
    Field, ErrorMessage, Form
  },
  created () {
    document.title = "Cumbre federal de logísitca 2026";
  },
  data() {
    return {
      isSubmitting: false,
      formData: {
        documento: '',
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        documento: yup.string().required('Ingrese su documento').min(7, 'Al menos 6 números'),
      });
    }
  },
  methods: {
    async onSubmit() {
      this.isSubmitting = true;

      let acreditado:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni="+this.formData.documento) as Acreditado;
      if(!acreditado) {
        this.isSubmitting = false;
        Swal.fire({ title: "¡Atención!",  html: "El acreditado no existe", icon: "error" });
        return;
      }

      if(acreditado.estadoAcreditado.id != VERIFICADO) {
        this.isSubmitting = false;
        Swal.fire({ title: "¡Atención!",  html: "Usted ya está inscripto<br/>Cerca de la fecha del evento se le enviará un QR de acreditación", icon: "error" });
        return;
      }
			
      try {
        location.href = "https://apps.qreventos.com/credencial/getCredencial?evento=" + suiteConfig.evento + "&hash=" + acreditado.hash;
      } finally {
        this.isSubmitting = false;
      }
    }
  }
});
</script>
